const context = require.context('./', true, /\.(js)$/)
const autoLoaded = {}

context.keys().forEach((filename) => {
  const queryKey = filename.split('/').pop().replace(/.js/i, '')
  if (queryKey !== 'index') autoLoaded[queryKey] = context(filename).default
})

export default autoLoaded



// WEBPACK FOOTER //
// ./src/i18n/en/index.js